import React from "react";
import {useLanguage} from "../hooks/LanguageContext";

const SectionHeadLin = ({ children }) => {
	const { direction } = useLanguage();
	return (
		<h2
			className={`headline-2-ar !font-bold whitespace-nowrap ${
				direction === "rtl" ? "text-right" : "text-left"
			} text-grayscale-600`}
		>
			{children}
		</h2>
	);
};

export default SectionHeadLin;
